
import React, {useState, useEffect} from 'react';
import { Avatar, Grid, Paper, FormControlLabel, Switch, Typography, 
  // Button, Box, TextField, InputLabel 
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import { useFileUpload } from 'core/hooks/useFileUpload';
// import { useSnackbar } from 'notistack';
// import { useForm, Controller } from "react-hook-form";
// import { uploadProfilePhoto } from 'core/services/profile';

const AccountLogo = ({accountDetails, profilePhoto}) => {
  // const defaultFormValues = {image: ''};
  const { active = 'N', name, email = '', mobile = '' } = accountDetails;
  const [profileImage, setProfileImage] = useState(profilePhoto);
  // const { enqueueSnackbar } = useSnackbar();
  // const { handleSubmit, control, formState: { errors } } = useForm({
  //   defaultValues: {...defaultFormValues}
  // });
  // const [fileInput, setFileInput] = useState();

  // const [uploadPhoto] = useFileUpload({
	// 	onStarting: (file) => {
  //     setFileInput(file);
	// 		var reader = new FileReader();
	// 		reader.readAsDataURL(file)
	// 		reader.onloadend = () => setProfileImage(reader.result)
  //     // onSubmit({image: file});
	// 	}
  // });

  useEffect(() => {
    setProfileImage(profilePhoto);
  }, [profilePhoto]);

  // const onSubmit = (data) => {
  //   var formData = new FormData();
  //   formData.append("image",fileInput);
  //   uploadProfilePhoto(formData).then(({response, error}) => {
  //     // console.log(response);
  //   });
  // };

  return (
    <Paper  sx={{py: 6, px: 3, boxShadow: 'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px'}}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        { profilePhoto ? (
          <Avatar variant="square" src={profileImage} sx={{ width: 200, height: 200 }} /> 
        ) : <Avatar variant="square" sx={{ width: 200, height: 200 }} >
          <AccountCircleIcon sx={{ fontSize: 150 }} />
        </Avatar>}
      </Grid>
      {/* <Grid container direction="row" justifyContent="center" alignItems="center" sx={{my: 1, p: 1}}>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{textAlign: "center"}} >
          <Box component="form" noValidate onSubmit={handleSubmit(onSubmit)} sx={{ mt: 1 }}>
            <Button variant="outlined" color="secondary" size="medium" sx={{m: 1}}>

                <Controller
                  control={control}
                  name="image"
                  id="image"
                  // rules={{ required: "Enter your mobile",
                  //   pattern: {
                  //     value: /^[0-9]{10}$/i,
                  //     message: "Enter a valid 10 digit mobile number",
                  //   },
                  // }}
                  render={({field }) => (
                    // <label htmlFor="image" >
                      <>
                      <TextField
                        {...field}
                        margin="normal"
                        type="file"
                        fullWidth
                        // sx={{display: 'none'}}
                        // autoFocus
                        // label="Mobile Number"
                        // required
                        // error={errors.mobile}
                        // helperText={errors.mobile?.message}
                        onChange={(e) => {uploadPhoto(e); return true;}}
                        />
                      </>
                      // </label>

                      // <input
                      //   {...field}
                      //   style={{ display: "none" }}
                      //   // id="profile-photo"
                      //   // name="profile-photo"
                      //   type="file"
                      //   onChange={uploadPhoto}
                      // />
                  )}
                />
            <InputLabel htmlFor="image" >Email address</InputLabel>

            </Button>
            <Button type="submit" variant="contained" color="success" size="medium" sx={{m: 1}}>
              Upload
            </Button>
          </Box>
        </Grid>
      </Grid> */}
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Typography variant="h6" component="p" sx={{mt: 3}}>
            {name}
          </Typography>
        </Grid>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Typography  component="p">
            {mobile}
          </Typography>
        </Grid>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Typography variant="caption"  sx={{mt: 1}}>
              {email}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{mt: 4}}
      >
        <FormControlLabel disabled control={<Switch checked={active === 'Y'} color="success" />} label="Active" labelPlacement="start" />
      </Grid>
    </Paper>
  );
}
 
export default AccountLogo;
